export default __webpack_public_path__ + "static/media/engaged-audiences.56be44cf.png";